export default "__VITE_ASSET__BuhvVxdH__"